import React, {useEffect, useState} from 'react';
import {Navigate, useParams} from "react-router-dom";
import Footer from '../components/Footer/Footer';
import {fetchEventsByQuery, fetchPerformersByQuery, fetchSearchResultByQuery, fetchVenuesByQuery} from '../api/endpoints';
import Event from '../interfaces/Event';
import Performer from '../interfaces/Performer';
import Venue from '../interfaces/Venue';
import Navbar from '../components/Navbar/Navbar';
import {isRight} from 'fp-ts/lib/Either';
import SearchResultsHeader from '../components/HomeSearch/SearchResultsHeader';
import QueryEvents from "../components/Events/QueryEvents";
import QueryPerformers from "../components/Events/QueryPerformers";
import QueryVenues from "../components/Events/QueryVenues";
import ShowsNearSection from "../components/ShowsNearSection/ShowsNearSection";


const SearchResultsPage: React.FC = () => {
    const { encodedQuery = '' } = useParams<{ encodedQuery: string }>();
    const query: string = React.useMemo(() => decodeURIComponent(encodedQuery), [encodedQuery]);
    const fromSearch = `/search/${encodedQuery}`;

    const [featuredEvents, setFeaturedEvents] = useState<Event[]>([]);
    const [loadingFeatured, setLoadingFeatured] = useState<boolean>(true);

    const [events, setEvents] = useState<Event[]>([]);
    const [loadingEvents, setLoadingEvents] = useState<boolean>(true);

    const [performers, setPerformers] = useState<Performer[]>([]);
    const [loadingPerformers, setLoadingPerformers] = useState<boolean>(true);

    const [venues, setVenues] = useState<Venue[]>([]);
    const [loadingVenues, setLoadingVenues] = useState<boolean>(true);

    useEffect(() => {
        if (query === '') return;

        const fetchFeatured = async () => {
            setLoadingFeatured(true);
            const searchResultEither = await fetchSearchResultByQuery(query);
            if (isRight(searchResultEither)) {
                setFeaturedEvents(searchResultEither.right.featured);
            } else {
                console.error(searchResultEither.left);
            }
            setLoadingFeatured(false);
        };

        const fetchEvents = async () => {
            setLoadingEvents(true);
            const eventsDataEither = await fetchEventsByQuery(query, false, 1);
            if (isRight(eventsDataEither)) {
                setEvents(eventsDataEither.right);
            } else {
                console.error(eventsDataEither.left);
            }
            setLoadingEvents(false);
        };

        const fetchPerformers = async () => {
            setLoadingPerformers(true);
            const performersDataEither = await fetchPerformersByQuery(query, true, 1);
            if (isRight(performersDataEither)) {
                setPerformers(performersDataEither.right);
            } else {
                console.error(performersDataEither.left);
            }
            setLoadingPerformers(false);
        };

        const fetchVenues = async () => {
            setLoadingVenues(true);
            const venuesDataEither = await fetchVenuesByQuery(query, 1);
            if (isRight(venuesDataEither)) {
                setVenues(venuesDataEither.right);
            } else {
                console.error(venuesDataEither.left);
            }
            setLoadingVenues(false);
        };

        fetchFeatured();
        fetchEvents();
        fetchPerformers();
        fetchVenues();
    }, [query]);


    if (query == '') {
        return <Navigate to="/not-found" />
    }

    return (
        <div>
            <Navbar key={query} showSearch={true}/>
            <SearchResultsHeader query={query}/>
            {(loadingFeatured || featuredEvents.length > 0) &&
                <QueryEvents query={""} initialEvents={featuredEvents} loadingEvents={loadingFeatured} sectionTitle="Featured" fromSearch={fromSearch} />
            }
            <ShowsNearSection />
            <QueryEvents query={query} initialEvents={events} loadingEvents={loadingEvents} fromSearch={fromSearch} />
            <QueryPerformers query={query} initialPerformers={performers} loading={loadingPerformers} />
            <QueryVenues query={query} initialVenues={venues} loading={loadingVenues} />
            <Footer/>
        </div>
    )
}

export default SearchResultsPage;
